module.exports = __webpack_public_path__ + "static/img/defend-a.18fe33ad.png";